import { DateTime } from 'luxon';

export function toBase64 (file) {
    return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });
}

export function leadingSlash (str) {
    return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash (str) {
    return str.endsWith('/') ? str : str + '/'
}

export const wait = timeout => {
    return new Promise(resolve => setTimeout(resolve, timeout))
}

export function parseFlightState(state){
    const states = {
        SCH: {
            name: 'Scheduled',
            color: 'secondary'
        },
        IBK: {
            name: 'In-block',
            color: 'success'
        },
        AIR: {
            name: 'Airborne',
            color: 'info'
        },
        CNX: {
            name: 'Cancelled',
            color: 'error'
        },
        TMA: {
            name: 'Approaching',
            color: 'primary'
        },
        FNL: {
            name: 'Final',
            color: 'warning'
        },
        FIR: {
            name: 'Approaching',
            color: 'info'
        },
        TAX: {
            name: 'Taxiing',
            color: 'warning'
        },
        DIV: {
            name: 'Diverted',
            color: 'secondary'
        },
        RTN: {
            name: 'Return',
            color: 'error'
        },
    }

    return states[state] || { name: 'Unknown', color: 'secondary' };;
}

export function stateToColor(state, color = true, returnAll = false){
    let states = {};
    if(color){
        states = {
            unconfirmed: 'error',
            confirmed: 'secondary',
            started: 'info',
            left: 'warning',
            finished: 'success',
            unknown: 'warning'
        }
    }else{
        states = {
            unconfirmed: 'Not Confirmed',
            confirmed: 'Confirmed',
            started: 'Started work',
            left: 'Left work',
            finished: 'Finished work',
            unknown: 'Unknown'
        }
    }
    if(returnAll){
        // last item is removed since its unknown, and we dont need that to be visible if its not actually used
        const keys = Object.keys(states);  // Retrieve keys of the object in insertion order
        if (keys.length > 0) {
            const lastKey = keys[keys.length - 1];  // Get the last key
            delete states[lastKey];  // Delete the last property
        }

        return states;
    }
    return states[state];
}
export function stringtoDateTime(ISOString, format = 'HH:mm'){
    if(ISOString){
        return DateTime.fromISO(ISOString).toFormat(format);
    }

    return 'UNK'
}

export function generateUserDetails(data) {
    const userDetails = [];
    // Process each state in the plannedWorkAttendanceStates array
    if (Array.isArray(data.plannedWorkAttendanceStates)) {
        data.plannedWorkAttendanceStates.forEach(state => {
            if (state.user) {
                userDetails.push({
                    usersign: state.user.usersign || '',
                    username: state.user.Firstname + ' ' + state.user.Lastname || '',
                    state: state.state || 'unknown'
                });
            }
        });
    }

    return userDetails;
}
